export enum ProductFlag {
  PB = 'PB',
  ONEPLUS1 = 'ONEPLUS1',
  TWOPLUS1 = 'TWOPLUS1',
  PRESENT = 'PRESENT',
  EXCLUSIVE = 'EXCLUSIVE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  SOLDOUT = 'SOLDOUT',
}

export enum ProductFlagType {
  PB = 'PB',
  ONEPLUS1 = '1+1',
  TWOPLUS1 = '2+1',
  PRESENT = '증정',
  EXCLUSIVE = '초특가',
  SPECIAL_DEAL = '네이버단독',
  SOLDOUT = '품절',
}

export const ProductFlagDesc = {
  ONEPLUS1: '1+1 행사',
  TWOPLUS1: '2+1 행사',
  PRESENT: '증정 행사',
  EXCLUSIVE: '초특가 행사',
  SPECIAL_DEAL: '네이버쇼핑 단독 특가',
}
